import { formatDistanceToNow } from 'date-fns';
import type { AgentScheduleResponse } from '@erp/rpc';
import { describeCronExpression } from 'src/components/common/CronInput';

export function scheduleRowIdentity(schedule: AgentScheduleResponse): {
  summary: string;
  description: string;
  identity: string;
} {
  const summary = describeCronExpression(schedule.cronExpression);
  const description = schedule.description?.trim() ?? '';
  return { summary, description, identity: description || summary };
}

type Translate = (
  message: string,
  options: { context: string; when?: string },
) => string;

export function scheduleNextRunLabel(
  schedule: AgentScheduleResponse,
  gt: Translate,
): string {
  if (!schedule.isEnabled) {
    return gt('Paused', {
      context: 'agent schedule row, schedule is disabled',
    });
  }
  if (!schedule.nextRunAt) {
    return gt('Next run unavailable', {
      context:
        'agent schedule row, schedule is enabled but its next fire time cannot be computed',
    });
  }
  return gt('Next run {when}', {
    when: formatDistanceToNow(schedule.nextRunAt, { addSuffix: true }),
    context:
      'agent schedule row, when the schedule fires next; {when} is a relative time like "in 3 hours"',
  });
}
